// https://splidejs.com/
import Splide from '@splidejs/splide';

const scenoSlider = {
	
	ui: {
		scrollTicking:false
	},

	init: function() {
		this.bindUI();
		this.bindEvents();

		// this.initSlider();
		this.displayHandle();
	},

	bindUI: function() {
		this.ui.$scenoSlider = $('.js-scenoSlider');
		this.ui.$scenoSliderSlick = this.ui.$scenoSlider.find(".js-scenoSlider__slick");
		this.ui.$scenoSliderSplide = this.ui.$scenoSlider.find(".js-scenoSlider__splide");
		this.ui.$scenoSliderScrollHandle = $('.js-scenoSlider__scrollHandle');
		this.ui.$scenoSliderImg = $('.js-scenoSlider img');
	},

	bindEvents: function() {
		this.ui.$scenoSliderSlick.on("beforeChange",function(event, slick, currentSlide, nextSlide){
			let $thumb = $(this).closest(".js-scenoSlider").find(".js-scenoSlider__scrollHandle-thumb");
			$thumb.css({
				"transform": "translate("+nextSlide*$thumb.width()+"px)"
			})
		});
		// on resize AND img load, show slider or not 
		$(window).on("resize", this.displayHandle.bind(this));
		this.ui.$scenoSliderImg.on("load", this.displayHandle.bind(this))
	},
	
	displayHandle: function(){
		let thas = this;
		this.ui.$scenoSliderSlick.each(function(){
			let $this = $(this);
			let $scenoSlide = $this.find(".js-scenoSlide");
			let $scenoSlider__inner = $this.closest(".js-scenoSlider__inner");
			let $scenoSlider__scrollHandle = $scenoSlider__inner.find(".js-scenoSlider__scrollHandle")
			let cummulWidth = 0;
			for (var i = 0; i < $scenoSlide.length; i++) {
				cummulWidth += $scenoSlide.eq(i).outerWidth();
			}
			console.log(cummulWidth);
			console.log($scenoSlider__inner.outerWidth());
			if(cummulWidth < $scenoSlider__inner.outerWidth()){
				$scenoSlider__scrollHandle.hide();
				$this.slick("slickSetOption", "swipeToSlide", false);
				$this.slick("slickSetOption", "swipe", false);
			}else{
				$scenoSlider__scrollHandle.show();
				$this.slick("slickSetOption", "swipeToSlide", true);
				$this.slick("slickSetOption", "swipe", true);
			}
		});
		this.ui.$scenoSliderSplide.each(function(){
			let $this = $(this);
			let $scenoSlide = $this.find(".js-scenoSlide");
			let $scenoSlider__inner = $this.closest(".js-scenoSlider__inner");
			let $scenoSlider__scrollHandle = $scenoSlider__inner.find(".js-scenoSlider__scrollHandle")
			let cummulWidth = 0;
			for (var i = 0; i < $scenoSlide.length; i++) {
				cummulWidth += $scenoSlide.eq(i).outerWidth();
			}

			var splide = new Splide( $this[0], {
				type   : 'slide',
				autoWidth: true,
				pagination: false,
				focus  : 0,
				snap  : true,
  				drag   : true,
  				arrows  : false
			});

			splide.on( 'dragged', function (e) {
				setTimeout(()=>{
					let $thumb = $(splide.root).closest(".js-scenoSlider").find(".js-scenoSlider__scrollHandle-thumb");
					$thumb.css({
						"transform": "translate("+(splide.index)*$thumb.width()+"px)"
					});
				},250);
			} );


			if(cummulWidth < $scenoSlider__inner.outerWidth()){
				$scenoSlider__scrollHandle.hide();
				splide.destroy();
			}else{
				$scenoSlider__scrollHandle.show();
				splide.mount();
			}
		});

	},

	// initSlider: function() {
	// 	this.ui.$scenoSliderSlick.slick({
	// 		touchMove: true,
	// 		swipe: true,
	// 		swipeToSlide: true,
	// 		dots: false,
	// 		infinite: false,
	// 		arrows:false,
	// 		// slidesToShow: 2,
	// 		centerMode: false,
	// 		variableWidth: true,
	// 		responsive: [
	// 			{
	// 				breakpoint: 500,
	// 				settings: {
	// 					// slidesToShow: 1,
	// 					centerMode: false,
	// 				}
	// 			}
	// 		]
	// 	});
	// },
};

module.exports = scenoSlider;